import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AddButton from 'focus_groups/components/add_button';
import { toggleAddModal } from 'focus_groups/ducks/view_state';

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    toggle: toggleAddModal,
  }, dispatch);
}

export default connect(null, mapDispatchToProps)(AddButton);



// WEBPACK FOOTER //
// ./focus_groups/containers/add_button.js